import React from "react";
import ReactHtmlParser from "react-html-parser";

export default function FAQ({ faqs }) {
  return (
    <>
      <h3>FAQs</h3>
      <div className="today-faqs">
        {faqs.map((items, keys) => (
          <div key={`sectorFaq${keys}`}>
            <h3>{items?.title} </h3>
            <div>{ReactHtmlParser(items?.description)} </div>
          </div>
        ))}
      </div>
    </>
  );
}
